import FormDialogComp from '@/components/formDialog/FormDialog.vue'
import store from "@/store"
import router from "@/router"
import Vue from 'vue'

const FormDialog = Vue.extend(FormDialogComp)
let isInstall = false
let instance = null

let isInstall2 = false
let instance2 = null

export default {
  install(Vue) {
    Vue.prototype.$formDialog = this.openDialog
    Vue.prototype.$formDialog2 = this.openDialog2
  },
  openDialog(option) {
    if (!isInstall) {
      instance = new FormDialog({router, store}).$mount()
      document.body.appendChild(instance.$el)
      isInstall = true
    }
    instance.dataViewVm = this
    return instance.open(option)
  },
  openDialog2(option) {
    if (!isInstall2) {
      instance2 = new FormDialog({router, store}).$mount()
      document.body.appendChild(instance2.$el)
      isInstall2 = true
    }
    instance2.dataViewVm = this
    return instance2.open(option)
  },
}
